import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtd92k72m5: FaireProductEntity = {
  token: "p_wtd92k72m5",
  type: "product",
  name: "WATERPROOF STAINLESS STEEL TARNISH FREE HOOPS | 40E306",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/29f02fc594b614e944872bb69f8adabfb936844c9c7d9e59f6aced0f86c98fc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60d3f13675470f303b14ac382cc6921051c44d3c7a550906e40a67f5e35594ef.jpeg",
    "https://cdn.faire.com/fastly/768e3a2c2edf7b5e9f4c8a48635574a0bcd0c37de85ae7072ed14eccd1eae687.jpeg",
    "https://cdn.faire.com/fastly/6171456434c9bbcad86141d0164235f0fb6c6fc72711d7ec8665eb7dc79f8d4b.jpeg",
    "https://cdn.faire.com/fastly/0ae5f77141107f24f60455dd2d6fe05955a7fc850ff197e1e1c5a36f5d703f14.jpeg",
    "https://cdn.faire.com/fastly/e793b383558a642d1b4c84b08eb0a1b2dd9b6f00250a70317b1e8e0b8c323514.jpeg",
    "https://cdn.faire.com/fastly/0c48c65a4ba6273f8ff57285caa4494805a1380aa81c1eb451de6d00813eede3.jpeg",
  ],
  priceDollars: 5.2,
  description:
    '18K Waterproof Stainless Steel Tarnish-Free Huggie Hoops, Made from high-quality stainless steel with a luxurious 18K gold finish, these huggie hoops offer both elegance and durability. Their waterproof and tarnish-free properties ensure they maintain their shine and luster, making them perfect for everyday wear, regardless of the conditions. \n\nProduct Details:\nlength:  .75"  - 1"\nwidth:    .75" - 1"                           \nearring back:  Stainless Steel Post\nmetal finish: 18K Stainless Steel\nproduct:  Lead & Nickel Compliant\nanti-tarnish:  tarnish free, non-tarnish\n\nReal Gold Dipped Earrings\nStainless Steel Earrings \nHypoallergenic Earrings\nTarnish-Free Earrings \nNon-Tarnish Earrings\nWater Proof Earrings \nWater Resistant Earrings\nSweatproof Jewelry\nFade Resistant Earrings \nAnti-oxidation \nLasting Shine \nPVD Coated\n\nGeometric Hoops | Simple Gold Earrings | Simple Lightweight Earrings | Minimalist Earrings ',
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:02.056Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
